import { render } from "./loading.vue?vue&type=template&id=6325c1bb&scoped=true"
import script from "./loading.vue?vue&type=script&lang=js"
export * from "./loading.vue?vue&type=script&lang=js"

import "./loading.vue?vue&type=style&index=0&id=6325c1bb&scoped=true&lang=css"

import exportComponent from "E:\\Proj\\Apps\\Stock\\vuestock\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6325c1bb"]])

export default __exports__